// libs
import { styled } from '@nykaa/ui-components';

// helpers
import { BREAKPOINTS } from 'shared/styles/base';

import { truncate } from 'shared/styles/mixin/core';

export const Container = styled.div`
  position: relative;
  left: 0;
  width: 100vw;
  margin-left: ${({ theme }) => `-${theme.spacing.spacing80}`};
  padding-left: ${({ theme }) => theme.spacing.spacing80};
  &:active,
  &:focus {
    background: rgba(101, 119, 134, 0.16);
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100%;
    margin-left: 0;
    padding-left: 0;
    &:hover {
      background: rgba(101, 119, 134, 0.08);
    }
  }
`;

export const HeaderContainer = styled.div<{ isExpanded: boolean }>`
  width: 100%;
  display: flex;
  padding-top: ${({ theme }) => theme.spacing.spacing80};
  ${({ isExpanded, theme }) => (isExpanded ? '' : `padding-bottom: ${theme.spacing.spacing80};`)};
`;

export const Header = styled.div<{ isExpanded: boolean }>`
  align-items: center;
  ${({ isExpanded, theme }) =>
    isExpanded
      ? `padding-bottom: ${theme.spacing.spacing40};`
      : `padding-bottom: ${theme.spacing.spacing10};`}

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ isExpanded, theme }) =>
      isExpanded
        ? `padding-bottom: ${theme.spacing.spacing60};`
        : `padding-bottom: ${theme.spacing.spacing10};`}
    transition: height 0.15s ease-out;
  }
`;

export const Subtitle = styled.div`
  ${truncate}

  ${({ theme }) => theme.typography.bodyMedium}
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-top: ${({ theme }) => theme.spacing.spacing10};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge}
  }
`;
export const HeaderIconContainer = styled.span`
  margin-right: ${({ theme }) => theme.spacing.spacing60};
  color: ${({ theme }) => theme.colors.textPrimary};
  height: 24px;

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-top: 0px;
    padding-left: ${({ theme }) => theme.spacing.spacing40};
    display: flex;
    align-items: center;
  }
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.titleSmall}
  color: ${({ theme }) => theme.colors.textPrimary};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.titleSmall};
    padding-bottom: ${({ theme }) => theme.spacing.spacing10};
  }
`;

export const EmptyIconPlaceHolder = styled.div`
  width: 24px;
  height: 24px;
`;
